<template>
  <ModalPlay size="md" :title="$t('tutor_online.rename_chat_modal.title')" @close="emit('close')">
    <InputPlayV3 id="history-rename-input" v-model="name" :placeholder="$t('tutor_online.rename_chat_modal.name_placeholder')"/>

    <template #footer>
      <ButtonPlayV2
        id="history-rename-cancel-btn"
        :text="$t('general.cancel')"
        variant="ghost"
        @click="emit('close')"
      />

      <ButtonPlayV2
        id="history-rename-save-btn"
        :text="$t('general.save')"
        variant="filled"
        @click="confirmRename"
      />
    </template>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ModalPlay } from '@/components/atomic'

const props = defineProps<{
  rename: (name: string) => void
  title: string
}>()

const emit = defineEmits<{
  close: []
}>()

const name = ref(props.title)

function confirmRename() {
  props.rename(name.value)
  emit('close')
}
</script>
